// src/services/leadStatusService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
    return localStorage.getItem('token');
  };
  const token = getToken();

export const getLeadStatuses = () => axios.get(`${API_URL}/lead-statuses`,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
export const getLeadStatusById = (id) => axios.get(`${API_URL}/lead-statuses/${id}`,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
export const createLeadStatus = (statusData) => axios.post(`${API_URL}/lead-statuses`, statusData,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
export const updateLeadStatus = (id, statusData) => axios.put(`${API_URL}/lead-statuses/${id}`, statusData,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
export const deleteLeadStatus = (id) => axios.delete(`${API_URL}/lead-statuses/${id}`,{
    headers: { Authorization: `Bearer ${token}` },  // Pass token in Authorization header
  });
